import type { IntentType } from "common/interfaces/CampaignIntent";
import type { InsightItem } from "../adSetCardUtils";
import { getInsightActionLabel } from "../adSetCardUtils";

/** How the primary action for an ad-level insight should behave in the UI. */
export type AdInsightPrimaryAction =
  | { type: "openReview"; label: string }
  | { type: "apply"; label: string }
  | { type: "none" };

/**
 * Single place for ad-level insight primary action behavior.
 * Add or adjust intent types here instead of scattering conditionals in the render.
 */
export function getAdInsightPrimaryAction(
  item: InsightItem
): AdInsightPrimaryAction {
  const intentType: IntentType = item.intent.intent_type;

  switch (intentType) {
    case "TOO_EARLY_TO_TELL":
      return { type: "none" };
    case "INFORM_CREATIVE_FATIGUE":
      return { type: "openReview", label: "View" };
    default:
      break;
  }

  if (item.variant === "neutral") {
    return { type: "openReview", label: "View" };
  }

  return {
    type: "apply",
    label: getInsightActionLabel(item.variant, "ad"),
  };
}
